import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import PublicidadSemIA from "@/pages/servicios/PublicidadSemIA";


export const Route = createFileRoute("/servicios/publicidad-sem-ia")({
  head: () => ({
    meta: [
      { title: "SEM con IA | Google Ads Optimizado con Inteligencia Artificial | SEOEVOLUTION" },
      { name: "description", content: "Google Ads sin IA es quemar dinero. Nuestra IA optimiza pujas 24/7, detecta keywords ineficientes y maximiza conversiones. ROI medio +250%. Diagnóstico de campañas." },
      { name: "keywords", content: "SEM, Google Ads, publicidad online, PPC, anuncios Google, publicidad IA, inteligencia artificial, machine learning, marketing digital" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/publicidad-sem-ia" },
      { property: "og:title", content: "SEM con IA | Google Ads Optimizado con Inteligencia Artificial | SEOEVOLUTION" },
      { property: "og:description", content: "Google Ads sin IA es quemar dinero. Nuestra IA optimiza pujas 24/7 y maximiza conversiones. ROI medio +250%." },
      { name: "twitter:title", content: "SEM con IA | Google Ads Optimizado con Inteligencia Artificial | SEOEVOLUTION" },
      { name: "twitter:description", content: "Google Ads sin IA es quemar dinero. Nuestra IA optimiza pujas 24/7 y maximiza conversiones. ROI medio +250%." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/publicidad-sem-ia" }],
    scripts: serviceSchemaScripts("publicidad-sem-ia"),
  }),
  component: PublicidadSemIA,
});
